import React from 'react';

import { Horizon, HorizonItem } from '../horizon-item/HorizonItem';
import styles from './HorizonSelector.module.scss';

export const HorizonSelector = ({
  horizons,
  selectedHorizon,
  handleHorizonChange,
  horizonToIndexMap,
  benchmarkTags,
  themeId,
}: {
  horizons: Horizon[];
  selectedHorizon: Horizon;
  handleHorizonChange: (horizon: Horizon) => void;
  horizonToIndexMap: Map<string, number>;
  benchmarkTags?: string[];
  themeId: string;
}) => {
  return (
    <div className={styles.root}>
      {horizons.map(horizon => (
        <HorizonItem
          key={horizon}
          horizonToIndexMap={horizonToIndexMap}
          horizon={horizon}
          isSelected={horizon === selectedHorizon}
          benchmarkTags={benchmarkTags}
          onClick={() => handleHorizonChange(horizon)}
          themeId={themeId}
        />
      ))}
    </div>
  );
};
